export default __webpack_public_path__ + "static/media/nu-image.1e392f93.png";